import { Action } from 'redux';

import { NormalizedFollowedLeadersEntities } from '../../normalization/graphql/normalizeFollowedLeaders.types';

export const userFollowedLeadersListRequestStatusKey = 'userFollowedLeadersListRequestKey';

export interface UserFollowedLeadersListLoadMorePendingAction extends Action {
  readonly type: 'FOLLOWED_LEADERS.LOAD_MORE_PENDING';
  readonly userFollowedLeadersListRequestStatusKey: string;
}

export interface UserFollowedLeadersListLoadMoreFulfilledAction extends Action {
  readonly type: 'FOLLOWED_LEADERS.LOAD_MORE_FULFILLED';
  readonly userFollowedLeadersListRequestStatusKey: string;
  readonly payload: {
    readonly entities: NormalizedFollowedLeadersEntities;
  };
}

export interface UserFollowedLeadersListLoadMoreRejectedAction extends Action {
  readonly type: 'FOLLOWED_LEADERS.LOAD_MORE_REJECTED';
  readonly userFollowedLeadersListRequestStatusKey: string;
  readonly payload: {
    readonly error: unknown;
  };
  readonly error: true;
}

export type UserFollowedLeadersListLoadMoreAction =
  | UserFollowedLeadersListLoadMorePendingAction
  | UserFollowedLeadersListLoadMoreFulfilledAction
  | UserFollowedLeadersListLoadMoreRejectedAction;
